import {FontAwesomeIcon as Icon} from "@fortawesome/react-fontawesome"
import AlertSuccess from "components/Alerts/AlertSuccess"
import SelectInput from "components/SelectInput"
import ToggleInput from "components/ToggleInput"
import {User} from "domain-models"
import _ from "lodash"
import Form from "mixins/form"
import {FormType} from "mixins/FormTypes"
import {Http} from "mixins/http"
import React from "react"
import {updateUser} from "redux/actions"
import {connect} from "react-redux"
import {GlobalState} from "../../../state"
import {store} from "../../../store"
import Trans from '../../../components/Trans'

type UpdateNotificationSettingsProps = {
  user: User
}

type UpdateNotificationSettingsState = {
  form: FormType
}

class UpdateNotificationSettings extends React.Component<UpdateNotificationSettingsProps, UpdateNotificationSettingsState> {
  private form: FormType = new Form({notifications: null, target: null})

  constructor(props: UpdateNotificationSettingsProps) {
    super(props)
    const subscription = _.first(this.props.user.notifications_subscription)
    this.form.notifications = !!subscription
    if (subscription) {
      this.form.target = _.toInteger(subscription.Target)
    }
    this.state = {
      form: this.form,
    }
  }

  update = async (event: React.MouseEvent) => {
    event.preventDefault()
    event.stopPropagation()

    this.setState({
      form: this.form
    })

    const newUser = await Http.put<User>('/employee/' + this.props.user.ars_id + '/subscribe', {
      state: this,
      form: this.state.form
    })

    if (!this.state.form.errors.hasErrors()) {
      store.dispatch(updateUser(newUser))
    }
  }

  render() {
    const targetOptions = [
      {value: 0, label: 'Immer'},
      {value: 1, label: 1},
      {value: 2, label: 2},
      {value: 3, label: 3},
      {value: 4, label: 4},
      {value: 5, label: 5},
      {value: 6, label: 6},
      {value: 7, label: 7},
      {value: 8, label: 8},
      {value: 9, label: 9},
      {value: 10, label: 10},
      {value: 11, label: 11},
      {value: 12, label: 12},
      {value: 13, label: 13},
      {value: 14, label: 14},
    ]
    return (
      <div className="flex flex-col lg:flex-row flex-wrap w-full">
        <div className="flex flex-col lg:flex-row w-full">
          <div className="text-gray-600 font-semibold tracking-wide w-full lg:w-1/3 text-center lg:text-left flex flex-col">
            <div className="whitespace-no-wrap">
              <Icon icon="id-card"/>
              <span> <Trans>Benachrichtigungen</Trans></span>
            </div>
          </div>
          <form className="w-full lg:w-2/3">
            {this.state.form.successful ?
              <AlertSuccess>
                <span><Trans>Ihre Benachrichtigungseinstellungen wurden erfolgreich gespeichert</Trans></span>
              </AlertSuccess>
              : null}
            <div>
              <label className="block tracking-wide text-gray-600 font-semibold mb-1"><Trans>Über neue Auktionen per E-Mail informieren</Trans></label>
              <ToggleInput toggled={this.state.form.notifications} update={toggled => {
                this.form.notifications = toggled
                this.setState({form: this.form})
              }}/>
            </div>

            <div className="mt-4">
              <label className="block tracking-wide text-gray-600 font-semibold mb-1"><Trans>E-Mail Benachrichtigung nur für Auktionen die maximal noch folgende Anzahl Tage laufen:</Trans></label>
              <SelectInput required={true} value={this.state.form.target} options={targetOptions} setOption={target => {
                this.form.target = target
                this.setState({form: this.form})
              }} labelField='label' keyField='value'/>
            </div>

            <div className="mt-4 flex justify-end">
              <button className={"rounded bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 font-semibold" + (this.state.form.busy ? ' cursor-not-allowed opacity-75' : '')} onClick={this.update}>
                {this.state.form.busy ?
                  <Icon icon="spinner" spin={true}/>
                  :
                  <Icon icon="user-edit"/>
                }
                <span> <Trans>Speichern</Trans></span>
              </button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default connect((state: GlobalState) => ({
  user: state.user,
}))(UpdateNotificationSettings)
